/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsEventDataSchema = z.object({
	app: z.string(),
	entityType: z.string(),
	entityId: z.string().uuid(),
	sessionId: z.string().uuid(),
	eventType: z.string(),
	metadata: z.record(z.string(), z.unknown()).nullable().optional(),
	timestamp: z.string().nullable().optional(),
})

export type AnalyticsEventDataSchema = z.infer<typeof analyticsEventDataSchema>
